import React from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentWrapper from './CustomPageDetailContentWrapper';
import LeadSurveyLoader from '../../survey/LeadSurveyLoader';

const CustomPageDetailContentSurveyBasicLayout = (props) => {

  let {
    pageBlock,
  } = props;

  return (
    <CustomPageDetailContentWrapper pageBlock={pageBlock}>
      <h1>SURVEY!!!!</h1>
      <LeadSurveyLoader />
    </CustomPageDetailContentWrapper>
  );
};

CustomPageDetailContentSurveyBasicLayout.propTypes = {
  pageBlock: PropTypes.shape({
    pageBlockId: PropTypes.string,
    pageBlockTypeCode: PropTypes.string,
    pageBlockTitle: PropTypes.string,
    pageBlockDescriptionHtml: PropTypes.string,
    pageBlockLayoutTypek: PropTypes.shape( {
      pageBlockLayoutTypeCode: PropTypes.string,
      pageBlockItemsPerLinePcViewCount: PropTypes.number,
      pageBlockItemsPerLineSpViewCount: PropTypes.number,
    }),
  }).isRequired,
};

export default CustomPageDetailContentSurveyBasicLayout;
